import http from "@/apis/http";
import url from "@/config/url";

const record = url.tgBusiness.reward.record;

export default {
  getGroupList: (params) => {
    return http.post(record.groupList, params);
  },
  getColumns: (params) => {
    return http.post(record.columns, params);
  },
  getData: (params) => {
    return http.post(record.search, params);
  },
  getUsers: (params) => {
    return http.post(record.users, params);
  },
  getDetail: (params) => {
    return http.post(record.detail, params);
  },
};
